export default __webpack_public_path__ + "static/media/background.a9254695.jpg";